import React from 'react';
import { Card, Statistic } from 'antd';
import {
  ClockCircleOutlined,
  CheckCircleOutlined,
  DollarOutlined,
  WarningOutlined,
  ShoppingOutlined
} from '@ant-design/icons';
import { formatNumber } from '../utils/orderUtils';
 import usePermission from '../hooks/usePermission';

/**
 * Displays metric cards for orders dashboard
 * 
 * @param {Object} metrics - Object containing order metrics
 * @param {boolean} showSchedulingWarnings - Whether admin-only scheduling warnings should render
 */
const OrderMetricsCards = ({ metrics, showSchedulingWarnings = false }) => {
  const {hasPermission} = usePermission();
  return (
    <div className={`grid grid-cols-1 md:grid-cols-2 ${showSchedulingWarnings ? 'lg:grid-cols-5' : 'lg:grid-cols-4'} gap-4 mb-6`}>
      <Card className="shadow-sm">
        <Statistic
          title="Active Orders"
          value={metrics.total_active || 0}
          prefix={<ClockCircleOutlined />}
          valueStyle={{ color: '#1890ff' }}
        />
      </Card>
      <Card className="shadow-sm">
        <Statistic
          title="Completed Orders"
          value={metrics.total_completed + (metrics.total_collected || 0)}
          prefix={<CheckCircleOutlined />}
          valueStyle={{ color: '#52c41a' }}
        />
      </Card>
       {hasPermission('total_sales_dashboard') && 
      <Card className="shadow-sm">
        <Statistic
          title="Total Revenue"
          value={`£${formatNumber(metrics.total_revenue || 0)}`}
          prefix={<DollarOutlined />}
          valueStyle={{ color: '#722ed1' }}
        />
      </Card>
      }
      {showSchedulingWarnings && (
        <Card className="shadow-sm">
          <Statistic
            title="Not Scheduled"
            value={`${metrics.not_scheduled || 0}`}
            prefix={<WarningOutlined />}
            valueStyle={{ color: '#faad14' }}
          />
        </Card>
      )}
      <Card className="shadow-sm">
        <Statistic
          title="Failed Orders"
          value={`${metrics.total_failed || 0}`}
          prefix={<ShoppingOutlined />}
         //color red aler
          valueStyle={{ color: '#ff4d4f' }}
        />
      </Card>
    </div>
  );
};

export default OrderMetricsCards;
